/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import {
  flexRender,
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  getFilteredRowModel,
} from '@tanstack/react-table'
import TablePagination from '../../components/TablePagination/TablePagination'
import notifyToast from '../../components/Toast/Toast'
import {ToastContainer} from 'react-toastify'
import {KTCard, KTCardBody, KTIcon} from '../../../_websoft/helpers'
import TableSearch from '../../components/TableSearch/TableSearch'
import ExportButton from '../../components/TableExportToExcel/ExportButton'
import {Link} from 'react-router-dom'
import {TableActionButton} from '../../components/TableActionBtn/TableActionButton'
import {useNavigate} from 'react-router-dom'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'
import {ParamsModelPrijavaKvara, PrijavaKvaraModel} from '../../models/PrijavaKvara'
import {deletePrijavaKvara, getAllPrijavaKvara} from '../../api/prijavaKvara'
import moments from 'moment/moment'
import {PaginationModel} from '../../models/PaginationModel'
import PrijavaKvaraFilteri from '../../components/PrijavaKvaraFilteri/PrijavaKvaraFilteri'

const PrijavaKvaraLista: React.FC = () => {
  const [data, setData] = useState<PrijavaKvaraModel[]>([])
  const [loading, setLoading] = useState(true)
  const [pagination, setpagination] = useState<PaginationModel>({
    curPage: 1,
    totalPage: 1,
    perPage: 10,
  })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [filter, setfilter] = useState('')
  const [params, setparams] = useState<ParamsModelPrijavaKvara>({per_page: 10, page: 1, active: 1})

  const [sorting, setSorting] = useState<SortingState>([])
  const [globalFilter, setGlobalFilter] = React.useState('')

  const updatePage = () => {
    setLoading(true)
    getAllPrijavaKvara(params)
      .then((response) => {
        const data = response.data['data']
        setData(data)
        const totalPage = Math.floor(response.data['total'] / response.data['per_page'] + 1)
        setpagination({
          curPage: response.data['current_page'],
          totalPage: totalPage,
          perPage: params.per_page,
        })
      })
      .catch((error) => {
        console.error('Error: ', error)
        notifyToast(false, error)
      })
      .finally(() => {
        setLoading(false)
      })
    console.log(data)
  }
  // Status cell
  const StatusCell = ({row}) => {
    return (
      row.original.status && (
        <div
          className='badge text-white'
          style={{
            backgroundColor: row.original.status.Boja,
            padding: '15px',
          }}
        >
          {row.original.status.Naziv}
        </div>
      )
    )
  }
  useEffect(() => {
    updatePage()
  }, [params])

  useEffect(() => {
    const {id} = sorting[0] ?? ''
    data.sort((a, b) => a[id] - b[id])
  }, [sorting])

  const columns = [
    {
      id: 'Id',
      header: 'Id',
      accessorKey: 'PrijavaId',
    },
    {
      id: 'Datum',
      header: 'Datum',
      accessorFn: (row) => `${moments(row.PrijavaDatum).format('DD-MM-YYYY')}`,
    },
    {
      id: 'Inv broj.',
      header: 'Inv broj.',
      accessorKey: 'PrijavaInvBroj',
    },
    {
      id: 'Sredstvo naziv',
      header: 'Sredstvo naziv',
      accessorKey: 'sredstvo.SredstvoNaziv',
    },
    {
      id: 'Opis kvara',
      header: 'Opis kvara',
      accessorKey: 'PrijavaOpisKvara',
    },
    {
      id: 'Kreirao prijavu',
      header: 'Kreirao prijavu',
      accessorKey: 'uposlenik_kreirao.UposlenikImePrezime',
    },
    {
      id: 'Voditelj intervencije',
      header: 'Voditelj intervencije',
      accessorKey: 'uposlenik_startao.UposlenikImePrezime',
    },
    {
      id: 'Datum / Vrijeme',
      header: 'Datum / Vrijeme',
      accessorFn: (row) => `${moments(row.PrijavaDatum).format('DD-MM-YYYY  h:mm:ss')}`,
    },
    {
      id: 'Status',
      header: 'Status',
      accessorKey: 'Status',
      cell: StatusCell,
    },
    {
      header: 'Akcija',
      accessorKey: 'Akcija',
      cell: ({row}) => (
        <TableActionButton
          onDelete={() => onDelete(row.original.PrijavaId)}
          onEdit={() => {
            onEdit(row.original.PrijavaId)
          }}
        />
      ),
    },
  ]
  const table = useReactTable({
    data: data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting: sorting,
      globalFilter: globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getFilteredRowModel: getFilteredRowModel(),
    onSortingChange: setSorting,
  })
  const onDelete = (id) => {
    deletePrijavaKvara(id)
      .then((response) => {
        let toast = true
        if (response.error === 1) toast = false
        notifyToast(toast, response.message)
        setparams({per_page: pagination.perPage, page: pagination.curPage})
      })
      .catch((error) => {
        notifyToast(false, error.data['message'])
      })
  }
  const navigate = useNavigate()

  const onEdit = (rowData) => {
    navigate(`/prijava-kvara/izmjena/${rowData}`)
  }
  const onFilter = (filters) => {
    setparams({...params, ...filters})
  }
  return (
    <KTCard>
      <ToastContainer />
      <KTCardBody className='py-4'>
        <PrijavaKvaraFilteri onFilter={onFilter} />
        <div className='d-flex justify-content-between'>
          <div data-kt-user-table-toolbar='base'>
            <TableSearch onSearch={(text) => setGlobalFilter(text)} />
          </div>
          <div data-kt-user-table-toolbar='base'>
            <ExportButton table={table} filename={'sredstva_lista'} />
            <Link to='dodaj'>
              <button type='button' className='btn btn-primary'>
                <KTIcon iconName='plus' className='fs-2' />
                Dodaj prijavu kvara
              </button>
            </Link>
          </div>
        </div>
        {loading ? (
          <LoadingComponent />
        ) : (
          <div className='table-responsive mt-3 '>
            <table className='table align-middle table-bordered gy-5 no-footer'>
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr
                    key={headerGroup.id}
                    className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-dark p-2'
                  >
                    {headerGroup.headers.map((header) => (
                      <th
                        className='text-white'
                        key={header.id}
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {/* @ts-ignore */}
                        {{asc: '🔼', desc: '🔽'}[header.column.getIsSorted() ?? null]}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody className='text-gray-600'>
                {table.getRowModel().rows && table.getRowModel().rows.length > 0 ? (
                  table.getRowModel().rows.map((row) => (
                    <tr key={row.id}>
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        No matching records found
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
        <TablePagination
          updatePage={(page, per_page) => setparams({...params, page: page, per_page: per_page})}
          pagination={pagination}
        />
      </KTCardBody>
    </KTCard>
  )
}
export default PrijavaKvaraLista
